import { getFileMediaType } from "helpers";
import { useState } from "react";

import { useDirectUpload } from "./api/useDirectUpload";
import { useUploadToS3 } from "./api/useUploadToS3";
import {
  DirectUploadMedia,
  DirectUploadToS3Options,
  FileWithMetadata
} from "./directUpload.types";

const defaultOptions = {
  onSuccess: null,
  onError: null
};

export const useDirectUploadToS3 = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<DirectUploadMedia | null>(null);
  const [error, setError] = useState<unknown>(null);

  const { mutateAsync: directUploadMutateAsync } = useDirectUpload();

  const { mutateAsync: uploadToS3MutateAsync } = useUploadToS3();

  const uploader = async (
    file: FileWithMetadata,
    options: DirectUploadToS3Options
  ) => {
    const { onSuccess, onError } = { ...defaultOptions, ...options };

    try {
      setIsLoading(true);

      const directUploadBody = {
        fileName: file.name,
        mediaType: getFileMediaType(file),
        size: file.size,
        contentType: file.type,
        width: file.width,
        height: file.height,
        directoryKey: options.directoryKey
      };

      const directUploadResponse =
        await directUploadMutateAsync(directUploadBody);

      const { media, signedUrl } = directUploadResponse;

      const uploadToS3Body = {
        url: signedUrl,
        body: file
      };

      await uploadToS3MutateAsync(uploadToS3Body, {
        onSuccess: () => {
          if (onSuccess) {
            onSuccess(media);
          }

          setData(media);
          setError(null);
        }
      });

      return media;
    } catch (err) {
      if (onError) {
        onError(err);
      }

      setData(null);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    data,
    error,
    uploader
  };
};
